import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SideNavFooterViewModel } from './side-nav-footer-view-model';
import { BaseComponent } from '../../../../../models/base/base-component';

@Component({
  selector: 'app-side-nav-footer',
  standalone: false,
  templateUrl: './side-nav-footer.component.html',
  styleUrl: './side-nav-footer.component.scss',
  providers: [SideNavFooterViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SideNavFooterComponent extends BaseComponent {
  constructor(public viewModel: SideNavFooterViewModel) {
    super();
  }
}
